package ai.wagemix.components.layouts

import ai.wagemix.SiteLogo
import ai.wagemix.ThemeToggle
import ai.wagemix.di.koin
import ai.wagemix.logic.WMNavigationRequest
import ai.wagemix.logic.WMRoutes
import ai.wagemix.navigate
import ai.wagemix.siteStrings
import ai.wagemix.web.screens.appshell.WMAppShellScreen
import ai.wagemix.web.screens.appshell.WMDefaultAppShellWebViewModel
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.compositionLocalOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.core.layout.Layout
import org.koin.core.parameter.parametersOf

/** A slot a page fills to put its primary actions into the shell's top bar. */
val LocalTopBarActions = compositionLocalOf<MutableState<(@Composable () -> Unit)?>> { error("Outside AppShellLayout") }

/** Penpot `App shell` around the logged-in pages; the shell presenter drives the sidebar. */
@Layout
@Composable
fun AppShellLayout(ctx: PageContext, content: @Composable () -> Unit) {
    val s = siteStrings
    val path = ctx.route.path
    val title = when {
        path.startsWith(WMRoutes.MIXES) -> s.savedMixes.title
        path.startsWith(WMRoutes.SHARED_LINKS) -> s.sharedLinks.title
        path.startsWith(WMRoutes.JOB_DESCRIPTIONS) -> s.jobDescriptions.title
        path.startsWith(WMRoutes.ACCOUNT) -> s.account.title
        path.startsWith(WMRoutes.PAYMENT_RESULT) -> s.payment.title
        else -> s.mixBuilder.title
    }
    val actions = remember { mutableStateOf<(@Composable () -> Unit)?>(null) }
    CompositionLocalProvider(LocalTopBarActions provides actions) {
        WMAppShellScreen(
            createViewModel = {
                koin.get<WMDefaultAppShellWebViewModel> { parametersOf({ request: WMNavigationRequest -> ctx.navigate(request) }) }
            },
            strings = s,
            activePath = path,
            pageTitle = title,
            logo = { SiteLogo() },
            themeToggle = { ThemeToggle() },
            topBarActions = actions.value?.let { slot -> { slot() } },
            // Only the builder has a logged-out form; "/mixes" shares the prefix and must keep the shell.
            loggedOutChrome = if (path == WMRoutes.MIX || path.startsWith("${WMRoutes.MIX}/")) {
                { inner -> MarketingLayout(ctx) { inner() } }
            } else {
                null
            }
        ) {
            content()
        }
    }
}
